import { useEffect, useState, useCallback } from 'react';
import requestSupportApis from '../../../../services/requestSupportApis';
import { IRequestSupport } from '../../interfaces/apis';
import { AxiosResponse } from 'axios';


const useGetAllRequestSupport = (isLazy = false) => {
  const [data, setData] = useState<IRequestSupport[] | null>(null);

  const fetchData = useCallback(async (param?: {shopId?: string}) => {
    try {
      const response: AxiosResponse<{ data: IRequestSupport[] }> = await requestSupportApis.getListRequestSupport(param?.shopId || null);
      if (response?.data?.data) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!isLazy) {
      fetchData();
    }
  }, [isLazy, fetchData]);


  return {
    data,
    refetch: fetchData,
  };
};

export default useGetAllRequestSupport;
